export const ROUTE_PARAM_OFFER_ID = 'offerId' as const;
export const ROUTE_PARAM_HEADQUARTER_ID = 'headquarterId' as const;
export const ROUTE_PARAM_ENTITY_ID = 'entityId' as const;

export const PARAM_OFFER_ID = `:${ROUTE_PARAM_OFFER_ID}` as const;
export const PARAM_HEADQUARTER_ID = `:${ROUTE_PARAM_HEADQUARTER_ID}` as const;
export const PARAM_ENTITY_ID = `:${ROUTE_PARAM_ENTITY_ID}` as const;

export type RouteStaticParam =
  | typeof ROUTE_PARAM_OFFER_ID
  | typeof ROUTE_PARAM_HEADQUARTER_ID
  | typeof ROUTE_PARAM_ENTITY_ID;
export type RouteParam = typeof PARAM_OFFER_ID | typeof PARAM_HEADQUARTER_ID | typeof PARAM_ENTITY_ID;

export type RouteError = '404' | '403';
export type RouteEntity =
  | 'admin'
  | 'broadcasting-program'
  | 'cache-file'
  | 'cache-list'
  | 'catering'
  | 'channels'
  | 'colleagues'
  | 'configuration'
  | 'contact-create'
  | 'contact'
  | 'contacts'
  | 'dictation'
  | 'eaccueils'
  | 'ets'
  | 'firmware'
  | 'ha'
  | 'headquarter'
  | 'headquarters-menu'
  | 'headquarters'
  | 'hq-administration'
  | 'hq-professionals'
  | 'hq-publications'
  | 'import-offers-data'
  | 'importmaterials'
  | 'jobs'
  | 'kiosks'
  | 'login'
  | 'materials'
  | 'messaging'
  | 'monitoring'
  | 'notifications'
  | 'offer-configuration'
  | 'offer-deploy-version'
  | 'offer-empty'
  | 'offer-menu'
  | 'offer'
  | 'offers'
  | 'password'
  | 'petits-journaux'
  | 'plannings'
  | 'post-pictures'
  | 'professionals'
  | 'proverb'
  | 'publication'
  | 'publications'
  | 'push-messages'
  | 'questions'
  | 'quiz'
  | 'residents'
  | 'rooms'
  | 'search'
  | 'service-notes'
  | 'services'
  | 'software'
  | 'teams'
  | 'tv-channels'
  | 'tv-packages'
  | 'updatebox'
  | 'users'
  | 'web-radios'
  | 'write-message';

export type RouteAction =
  | 'bind-pro'
  | 'change-offer'
  | 'confirmation'
  | 'create'
  | 'customs'
  | 'define-password'
  | 'deploy'
  | 'details'
  | 'duplicate'
  | 'edit-offer'
  | 'edit'
  | 'expired-token'
  | 'export'
  | 'export-content'
  | 'headquarter-details'
  | 'import-deploy'
  | 'import-offer-settings'
  | 'manage-display'
  | 'offer'
  | 'passwordEdit'
  | 'reset-password'
  | 'run-task'
  | 'test'
  | 'validation'
  | 'write'
  | 'custom-layout';

export type RouteOutletAction = 'offer-empty';
